function renderHTML(element, _a, styleProp, projection) {
  var style = _a.style,
    vars = _a.vars;
  Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
  // Loop over any CSS variables and assign those.
  for (var key in vars) {
    element.style.setProperty(key, vars[key]);
  }
}
export { renderHTML };